export default function DefaultContainer({ children }) {
  return (
    <div className="w-full px-6 py-4">{children}</div>
  );
}
